{
  "actions": {
    "new": "مورد جديد",
    "archive": "أرشفة",
    "restore": "استعادة",
    "newPurchase": "فاتورة شراء جديدة",
    "pay": "الدفع للمورد",
    "newReturn": "مرتجع أو خصم جديد",
    "refund": "تسجيل استرداد",
    "credit": "الرصيد غير المطبّق والاستردادات",
    "printStatement": "طباعة كشف الحساب",
    "retryFigures": "إعادة تحميل الرصيد",
    "open": "فتح",
    "statement": "كشف الحساب",
    "rowActions": "إجراءات {{name}}",
    "export": "تصدير العرض"
  },
  "fields": {
    "code": "الرمز",
    "name": "الاسم",
    "nameAr": "الاسم بالعربية",
    "company": "الشركة",
    "contactPerson": "الشخص المسؤول",
    "mobile": "الهاتف المحمول",
    "phone": "الهاتف",
    "email": "البريد الإلكتروني",
    "address": "العنوان",
    "city": "المدينة",
    "country": "الدولة",
    "status": "الحالة",
    "groups": "المجموعات",
    "taxNumber": "الرقم الضريبي",
    "notes": "ملاحظات",
    "bankName": "البنك",
    "bankAccountName": "اسم الحساب",
    "bankAccountNumber": "رقم الحساب",
    "bankIban": "رقم الآيبان",
    "bankSwift": "رمز السويفت",
    "createdAt": "تاريخ الإنشاء",
    "updatedAt": "آخر تعديل",
    "balance": "الرصيد",
    "overdue": "المتأخر",
    "unallocatedCredit": "رصيد غير مطبّق"
  },
  "status": {
    "ACTIVE": "نشط",
    "INACTIVE": "غير نشط",
    "ARCHIVED": "مؤرشف"
  },
  "list": {
    "title": "الموردون",
    "tableLabel": "الموردون",
    "views": "طرق عرض الموردين",
    "view": {
      "current": "الكل",
      "active": "النشطون",
      "inactive": "غير النشطين",
      "archived": "المؤرشفون"
    },
    "searchLabel": "البحث في الموردين",
    "searchPlaceholder": "ابحث بالاسم أو الرمز أو الهاتف…",
    "clearSearch": "مسح البحث",
    "groupFilter": "التصفية حسب المجموعة",
    "allGroups": "كل المجموعات",
    "clearFilters": "مسح عوامل التصفية",
    "empty": {
      "title": "لا يوجد موردون بعد.",
      "body": "أضف موردك الأول لتسجيل المشتريات والمصروفات عليه.",
      "filteredTitle": "لا يوجد موردون مطابقون.",
      "filteredBody": "جرّب اسمًا أو رمزًا أو رقم هاتف آخر، أو امسح عوامل التصفية.",
      "view": {
        "current": "لا يوجد موردون بعد.",
        "active": "لا يوجد موردون نشطون.",
        "inactive": "لا يوجد موردون غير نشطين.",
        "archived": "لا يوجد موردون مؤرشفون."
      },
      "balance": {
        "owes": "لا شيء مستحق علينا لأي مورد.",
        "overdue": "لا شيء متأخر.",
        "credit": "ليس لنا رصيد لدى أي مورد."
      }
    },
    "overdueMarker": "جزء منه متأخر",
    "creditHeld": "رصيد لنا: المورد مدين لنا بـ {{amount}}",
    "exportHint_zero": "لا موردين في هذا العرض",
    "exportHint_one": "ملف CSV بالمورد الوحيد في هذا العرض",
    "exportHint_two": "ملف CSV بالموردَين في هذا العرض",
    "exportHint_few": "ملف CSV بـ {{n}} موردين في هذا العرض",
    "exportHint_many": "ملف CSV بـ {{n}} موردًا في هذا العرض",
    "exportHint_other": "ملف CSV بـ {{n}} مورد في هذا العرض",
    "balanceView": {
      "owes": "المستحق علينا",
      "overdue": "المتأخر",
      "credit": "رصيد لنا"
    },
    "stats": {
      "label": "أرقام الموردين",
      "active": "الموردون النشطون",
      "ofAll": "من {{total}}",
      "activeShare": "{{percent}}٪ من الموردين نشطون",
      "owed": "المستحق علينا",
      "owedDetail": "موزع على {{suppliers}}",
      "overdueShare": "{{percent}}٪ مما علينا متأخر",
      "overdue": "المتأخر",
      "credit": "رصيد لنا",
      "unavailable": "الأرقام غير متاحة",
      "suppliers_zero": "لا موردين",
      "suppliers_one": "مورد واحد",
      "suppliers_two": "موردان",
      "suppliers_few": "{{n}} موردين",
      "suppliers_many": "{{n}} موردًا",
      "suppliers_other": "{{n}} مورد"
    }
  },
  "detail": {
    "record": "السجل",
    "noBank": "لا توجد بيانات بنكية.",
    "noBankHint": "لا توجد بيانات بنكية بعد. عدّل المورد لإضافتها قبل الدفع بالتحويل."
  },
  "new": {
    "title": "مورد جديد",
    "subtitle": "يُخصَّص رمز المورد عند الحفظ."
  },
  "edit": {
    "title": "تعديل {{name}}",
    "subtitle": "تعديل المورد",
    "archivedTitle": "هذا المورد مؤرشف",
    "backToSupplier": "العودة إلى المورد"
  },
  "form": {
    "save": "حفظ المورد",
    "saveHint": "اضغط {{shortcut}} للحفظ",
    "sections": {
      "identity": "الهوية",
      "contact": "الاتصال",
      "address": "العنوان",
      "bank": "البيانات البنكية",
      "classification": "التصنيف",
      "taxNotes": "الضريبة والملاحظات"
    },
    "hints": {
      "company": "الاسم القانوني أو التجاري، إن كان مختلفًا عن اسم المورد.",
      "groupsUnavailable": "تعذّر تحميل المجموعات. يمكنك إضافتها لاحقًا.",
      "bank": "الحساب الذي تُحوَّل إليه مدفوعات هذا المورد.",
      "iban": "يبدأ رقم الآيبان العُماني بـ OM ويتكون من 23 خانة."
    },
    "groupsPlaceholder": "اختر المجموعات",
    "groupsSearch": "ابحث في المجموعات…",
    "groupsEmpty": "لا توجد مجموعات.",
    "groupsClear": "مسح الاختيار",
    "groupsSelected": "{{n}} مجموعات",
    "errors": {
      "title": "لم يُحفظ المورد",
      "mobileTaken": "رقم الهاتف المحمول هذا مستخدم لمورد آخر.",
      "taxNumberTaken": "هذا الرقم الضريبي مستخدم لمورد نشط آخر.",
      "archived": "استعد هذا المورد قبل تعديله."
    },
    "conflict": {
      "title": "عدّل شخص آخر هذا المورد",
      "body": "لم تُحفظ تغييراتك. أعد التحميل لعرض أحدث نسخة، ثم أعد إجراء تغييراتك.",
      "reload": "تحميل أحدث نسخة"
    },
    "leave": {
      "title": "تجاهل التغييرات غير المحفوظة؟",
      "body": "لديك تغييرات في هذه الصفحة لم تُحفظ بعد.",
      "confirm": "تجاهل التغييرات",
      "cancel": "متابعة التعديل"
    }
  },
  "archive": {
    "title": "أرشفة {{name}}؟",
    "body": "يُخفى الموردون المؤرشفون من القوائم ولا يمكن استخدامهم في المستندات الجديدة. يمكنك استعادتهم في أي وقت.",
    "restoreTitle": "استعادة {{name}}؟",
    "restoreBody": "يعود المورد إلى القوائم ويمكن استخدامه في المستندات الجديدة مرة أخرى."
  },
  "toast": {
    "created": "تم إنشاء المورد {{code}}",
    "updated": "تم حفظ المورد",
    "archived": "تمت أرشفة المورد",
    "restored": "تمت استعادة المورد",
    "exported_zero": "لم يُصدَّر أي مورد",
    "exported_one": "صُدّر مورد واحد",
    "exported_two": "صُدّر موردان",
    "exported_few": "صُدّر {{n}} موردين",
    "exported_many": "صُدّر {{n}} موردًا",
    "exported_other": "صُدّر {{n}} مورد",
    "exportedView": "صُدّر العرض"
  },
  "groups": {
    "title": "مجموعات الموردين",
    "subtitle": "صنّف الموردين في مجموعات للتقارير والتصفية.",
    "new": "مجموعة جديدة",
    "newTitle": "مجموعة موردين جديدة",
    "newSubtitle": "سمِّ المجموعة بلغة واحدة أو باللغتين.",
    "editTitle": "تعديل مجموعة الموردين",
    "save": "حفظ المجموعة",
    "actions": "إجراءات",
    "editNamed": "تعديل {{name}}",
    "deleteNamed": "حذف {{name}}",
    "showMembers": "عرض الموردين في {{name}}",
    "fields": {
      "name": "الاسم",
      "nameAr": "الاسم بالعربية",
      "description": "الوصف",
      "members": "الموردون"
    },
    "empty": {
      "title": "لا توجد مجموعات موردين بعد.",
      "body": "أنشئ مجموعات مثل محلي أو خارجي لتصفية الموردين وإعداد التقارير عنهم."
    },
    "errors": {
      "nameTaken": "توجد مجموعة بهذا الاسم بالفعل.",
      "conflict": "عدّل شخص آخر هذه المجموعة أثناء تعديلك لها. أغلق اللوحة وافتح المجموعة مرة أخرى لترى تعديله."
    },
    "delete": {
      "title": "حذف {{name}}؟",
      "body_zero": "ستُحذف المجموعة. لا يوجد موردون فيها.",
      "body_one": "ستُزال المجموعة من مورد واحد. يبقى المورد نفسه دون تغيير.",
      "body_two": "ستُزال المجموعة من موردَين. يبقى الموردان دون تغيير.",
      "body_few": "ستُزال المجموعة من {{n}} موردين. يبقى الموردون أنفسهم دون تغيير.",
      "body_many": "ستُزال المجموعة من {{n}} موردًا. يبقى الموردون أنفسهم دون تغيير.",
      "body_other": "ستُزال المجموعة من {{n}} مورد. يبقى الموردون أنفسهم دون تغيير.",
      "confirm": "حذف المجموعة"
    },
    "toast": {
      "created": "تم إنشاء المجموعة",
      "updated": "تم حفظ المجموعة",
      "deleted": "تم حذف المجموعة"
    }
  },
  "errors": {
    "SUPPLIER_HAS_BALANCE": "ما زال علينا مبلغ لهذا المورد أو لنا رصيد لديه. سدّد الرصيد وطبّق الرصيد الدائن أو استرده، ثم أرشفه.",
    "SUPPLIER_HAS_OPEN_CHEQUES": "لدينا شيكات صادرة لهذا المورد لم يصرفها البنك بعد. أرشِف المورد بعد صرفها، أو بعد تسجيل ارتجاعها أو إلغائها.",
    "SUPPLIER_HAS_DRAFTS": "لدى هذا المورد مشتريات أو مرتجعات في المسودة. رحّلها أو احذفها، ثم أرشفه.",
    "GROUP_IN_USE": "تعتمد مسارات اعتماد على هذه المجموعة ({{workflows}}). أزلها من شروطها أولًا، ثم احذفها."
  },
  "archiveBlocked": {
    "balance": "ادفع أولًا الرصيد المستحق {{amount}}.",
    "credit": "استرد أو طبّق أولًا الرصيد {{amount}}.",
    "openCredit": "طبّق أولًا الرصيد {{amount}} على فواتير الشراء المفتوحة.",
    "checking": "جارٍ التحقق من الرصيد…",
    "unavailable": "تعذّر تحميل الرصيد."
  },
  "profile": {
    "figures": "أرقام الحساب",
    "figuresFailed": "تعذّر تحميل أرقام الحساب.",
    "balanceOwed": "المستحق علينا",
    "creditHeld": "رصيد لنا",
    "nothingOwed": "لا شيء مستحق",
    "overdue": "المتأخر",
    "oldest": "الأقدم {{bucket}}",
    "nothingOverdue": "لا شيء متأخر",
    "unappliedCredit": "رصيد غير مطبّق",
    "creditSources_zero": "لا مستندات",
    "creditSources_one": "في مستند واحد",
    "creditSources_two": "في مستندين",
    "creditSources_few": "في {{count}} مستندات",
    "creditSources_many": "في {{count}} مستندًا",
    "creditSources_other": "في {{count}} مستند",
    "lastPurchase": "آخر فاتورة شراء",
    "lastPayment": "آخر سند صرف",
    "none": "لا شيء بعد",
    "netPurchasesHead": "صافي المشتريات",
    "purchaseCount_zero": "لا فواتير شراء",
    "purchaseCount_one": "فاتورة شراء واحدة، دون الضريبة",
    "purchaseCount_two": "فاتورتا شراء، دون الضريبة",
    "purchaseCount_few": "{{count}} فواتير شراء، دون الضريبة",
    "purchaseCount_many": "{{count}} فاتورة شراء، دون الضريبة",
    "purchaseCount_other": "{{count}} فاتورة شراء، دون الضريبة",
    "aging": "أعمار الرصيد المستحق",
    "agingCurrency": "ر.ع.",
    "agingFailed": "تعذّر تحميل الأعمار.",
    "agingUnavailable": "الأعمار غير متاحة.",
    "bucket": {
      "current": "لم يستحق بعد",
      "days1to30": "1–30",
      "days31to60": "31–60",
      "days61to90": "61–90",
      "over90": "+90"
    },
    "bucketLong": {
      "days1to30": "1–30 يومًا",
      "days31to60": "31–60 يومًا",
      "days61to90": "61–90 يومًا",
      "over90": "أكثر من 90 يومًا"
    },
    "tabs": {
      "label": "أقسام المورد",
      "overview": "نظرة عامة",
      "purchases": "المشتريات",
      "payments": "سندات الصرف",
      "returns": "المرتجعات",
      "statement": "كشف الحساب",
      "tasks": "المهام",
      "attachments": "المرفقات"
    },
    "archivedBanner": "أُرشف في {{date}}. لا يمكن استخدامه في مستندات جديدة، وتبقى سجلاته متاحة للاطلاع.",
    "inactiveBanner": "غير نشط: لا فواتير شراء جديدة. تبقى سندات الصرف والمرتجعات والاستردادات متاحة لتسوية الأرصدة القديمة.",
    "showAllNotes": "عرض الكل",
    "attention": {
      "title": "يحتاج إلى متابعة",
      "none": "لا شيء يحتاج إلى متابعة.",
      "unavailable": "غير متاح.",
      "overdue_zero": "فواتير شراء متأخرة",
      "overdue_one": "فاتورة شراء متأخرة",
      "overdue_two": "فاتورتا شراء متأخرتان",
      "overdue_few": "فواتير شراء متأخرة",
      "overdue_many": "فاتورة شراء متأخرة",
      "overdue_other": "فاتورة شراء متأخرة",
      "drafts_zero": "مسودات للترحيل",
      "drafts_one": "مسودة فاتورة شراء للترحيل",
      "drafts_two": "مسودتا فاتورة شراء للترحيل",
      "drafts_few": "مسودات فواتير شراء للترحيل",
      "drafts_many": "مسودة فاتورة شراء للترحيل",
      "drafts_other": "مسودة فاتورة شراء للترحيل",
      "draftReturns_zero": "مسودات مرتجعات للترحيل",
      "draftReturns_one": "مسودة مرتجع للترحيل",
      "draftReturns_two": "مسودتا مرتجع للترحيل",
      "draftReturns_few": "مسودات مرتجعات للترحيل",
      "draftReturns_many": "مسودة مرتجع للترحيل",
      "draftReturns_other": "مسودة مرتجع للترحيل",
      "credit": "رصيد غير مطبّق — طبّقه أو استرده"
    },
    "recent": {
      "title": "أحدث المستندات",
      "none": "لا مستندات بعد."
    },
    "kind": {
      "purchase": "فاتورة شراء",
      "payment": "سند صرف"
    },
    "payTo": {
      "title": "الدفع إلى",
      "copy": "نسخ",
      "copied": "نُسخ",
      "copyNamed": "نسخ {{what}}",
      "copyFailed": "تعذّر النسخ. حدّد النص وانسخه."
    }
  },
  "docs": {
    "views": {
      "purchases": {
        "label": "عروض المشتريات",
        "all": "الكل",
        "open": "المفتوحة",
        "overdue": "المتأخرة",
        "drafts": "المسودات",
        "void": "الملغاة"
      },
      "payments": {
        "label": "عروض سندات الصرف",
        "all": "الكل",
        "withCredit": "رصيد غير مطبّق",
        "void": "الملغاة"
      },
      "returns": {
        "label": "عروض المرتجعات",
        "all": "الكل",
        "withCredit": "رصيد غير مطبّق",
        "drafts": "المسودات",
        "void": "الملغاة"
      }
    },
    "empty": {
      "purchases": "لا توجد مشتريات من هذا المورد بعد.",
      "payments": "لا توجد سندات صرف لهذا المورد بعد.",
      "returns": "لا توجد مرتجعات أو خصومات لهذا المورد بعد.",
      "view": "لا شيء في هذا العرض.",
      "next": {
        "purchases": "سجّل فاتورة المورد عند وصول البضائع.",
        "payments": "سجّل سند صرف عند الدفع للمورد.",
        "returns": "أرجع بضائع من فاتورة شراء، أو سجّل خصمًا منحه المورد."
      }
    },
    "rowActions": "إجراءات {{number}}"
  },
  "credit": {
    "title": "الرصيد غير المطبّق",
    "held": "الإجمالي {{amount}}",
    "sources": "مستندات برصيد غير مطبّق",
    "sourcesHint": "سندات صرف فيها دفعة مقدمة ومرتجعات لم تُطبّق على فواتير الشراء ولم تُسترد.",
    "none": "لا رصيد غير مطبّق.",
    "truncated": "تُعرض الأحدث فقط.",
    "available": "غير مطبّق",
    "allocate": "تطبيق",
    "refund": "استرداد",
    "refunds": "الاستردادات المستلمة",
    "noRefunds": "لا استردادات بعد.",
    "allRefunds": "كل الاستردادات من هذا المورد",
    "source": {
      "PAYMENT": "سند صرف",
      "SUPPLIER_RETURN": "مرتجع"
    },
    "applyTo": "تطبيق {{number}} على فواتير الشراء",
    "refundFrom": "استرداد من {{number}}"
  },
  "picker": {
    "required": "اختر المورد"
  },
  "quickCreate": {
    "action": "مورد جديد",
    "actionTyped": "مورد جديد «{{typed}}»",
    "title": "مورد جديد",
    "body": "الأساسيات الآن، والباقي في صفحة المورد.",
    "save": "إضافة المورد",
    "created": "أُضيف المورد {{name}}",
    "later": "يمكن إضافة العنوان والمجموعات والبيانات المصرفية وجهة الاتصال في صفحة المورد."
  }
}
